"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const use_safe_timeout_1 = require("../hooks/use-safe-timeout");
const appearDelay = 40;
var TransitionState;
(function (TransitionState) {
    TransitionState["INIT"] = "init";
    TransitionState["APPEAR"] = "appear";
    TransitionState["SHOW"] = "show";
    TransitionState["EXIT"] = "exit";
    TransitionState["IDLE"] = "idle";
})(TransitionState || (TransitionState = {}));
function useTransitionState(opened, options) {
    const [state, setState] = (0, react_1.useState)(TransitionState.INIT), { duration = 0 } = (0, react_1.useMemo)(() => options || {}, [options]), setSafeTimeout = (0, use_safe_timeout_1.useSafeTimeout)();
    const close = (0, react_1.useCallback)(() => {
        if (!/appear|show/.test(state))
            return;
        return new Promise((resolve) => {
            setState(TransitionState.EXIT);
            setSafeTimeout(() => {
                setState(TransitionState.IDLE);
                resolve(true);
            }, duration);
        });
    }, [opened, state]);
    (0, react_1.useEffect)(() => {
        if (opened && /init|idle/.test(state)) {
            setState(TransitionState.APPEAR);
            setSafeTimeout(() => setState(TransitionState.SHOW), appearDelay);
        }
        !opened && close();
    }, [opened]);
    return [state, close];
}
exports.default = useTransitionState;
